import { render, staticRenderFns } from "./AdminTickets.vue?vue&type=template&id=0a1d836e"
import script from "./AdminTickets.vue?vue&type=script&lang=js"
export * from "./AdminTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports